import React from 'react'
import { localized } from '@/decorators/localized'
import CommentItem, { visibilityTypes } from './CommentItem'
import uuid from 'uuid'
import LoadingIndicator from '@/components/LoadingIndicator'
import CommentInput from '@/components/comments/CommentInput'
import moment from 'moment'

@localized()
class Comments extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      comments: props.comments,
      showDialog: false,
      parentId: null,
      author: props.author || `< ${props.localize('Common.UnknownUser')} >`
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({ comments: nextProps.comments })
  }

  addComment = (newComment) => {
    if (this.props.disabled === true) { return }

    const { author } = this.state
    const dto = {
      ...newComment,
      id: uuid(),
      author,
      creationTime: moment()
    }

    this.props.onCommentCreated(dto)
  }

  render () {
    const { localize, disabled, showExternalVisibilityCheckbox } = this.props
    return (
      <React.Fragment>
        {this.props.isAddingComment && <LoadingIndicator />}
        {!this.props.isAddingComment && <div className='comments'>
          {disabled !== true && <CommentInput disabled={disabled} showExternalVisibilityCheckbox={showExternalVisibilityCheckbox} onCommentCreated={this.addComment} size='lg' />}

          <div className='CommentItems'>
            {this.state.comments.map((comment, index) => <CommentItem key={index} disabled={disabled} showExternalVisibilityCheckbox={showExternalVisibilityCheckbox && comment.visibility === visibilityTypes.EXTERNAL} {...comment} onCommentCreated={this.addComment} localize={localize} />)}
          </div>
        </div>}
      </React.Fragment>
    )
  }
}

export default Comments



// WEBPACK FOOTER //
// ./src/components/comments/Comments.js